import styled from 'styled-components';
import Trust from '../../assets/trust.png';

const Outer = styled.div`
  background: #faf5f3;
  padding: 1.5rem 1.5rem 0rem; /* Reduced bottom padding */
  @media (min-width: 768px) {
    padding: 0rem 5rem 2rem; /* Top, horizontal, bottom */
  }
`;


const FlexRow = styled.div`
  background: #faf5f3;
  border-radius: 20px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  @media (min-width: 768px) {
    flex-direction: row;
  }
`;

const Left = styled.div`
  flex: 1;
  background: #f87b15;
  color: #000;
  padding: 2rem;
  @media (min-width: 768px) {
    padding: 4rem;
  }
`;

const Title = styled.h1`
  font-weight: 700;
  font-size: 1.875rem;
  line-height: 1.2;
  text-transform: none;
  margin-bottom: 1rem;
  @media (min-width: 768px) {
    font-size: 2.5rem;
  }
`;

const Desc = styled.p`
  font-weight: 400;
  font-size: 1rem;
  color:rgb(0, 0, 0);
  margin-bottom: 2rem;
  line-height: 1.5;
  @media (min-width: 768px) {
    font-size: 1.125rem;
  }
`;

const Action = styled.a`
  font-weight: 400;
  background: #1f2937;
  color: #fff;
  padding: 0.5rem 1.25rem;
  border-radius: 9999px;
  font-size: 0.875rem;
  text-decoration: none;
  display: inline-block;
`;

const Right = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  
`;

const Img = styled.img`
  width: 100%;
  height: auto;
  object-fit: cover;
  @media (min-width: 768px) {
    height: 440px;
    border-top-right-radius: 20px;
    border-bottom-right-radius: 20px;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  @media (max-width: 767px) {
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
  }
`;

export default function TrustBlock() {
  return (
    <Outer>
      <FlexRow>
        <Left>
          <Title>
            Precision you can feel, <br />
            performance you can trust
          </Title>
          <Desc>
            Step into a world where sensors aren't just smart—they're Sensforge
            smart. Elevate your performance with cutting-edge precision,
            durability, and seamless integration.
          </Desc>
          <Action href="#">Take Action</Action>
        </Left>
        <Right>
          <Img src={Trust} alt="Trust visual" />
        </Right>
      </FlexRow>
    </Outer>
  );
}
